 $('.anouncement-slides').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  autoplay: true
});

 $('.home-banner-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
   dots: false,
  autoplay: true
});

$('.home-feature-outer').slick({
    arrows: false,
    pauseOnHover: true,
    autoplay: true,
    autoplaySpeed: 0,  // Infinite scrolling effect
    speed: 3000,  // Control speed of the sliding effect
    infinite: true,
    variableWidth: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    cssEase: 'linear',  // Ensures smooth continuous scrolling
    centerMode: true,   // Helps avoid empty spaces
    autoplaySpeed: 0,   // Creates a seamless effect
    focusOnSelect: false
});
 $('.home-reviews-right, .installer-steps-wrapper').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
   dots: false,
  autoplay: false,
   infinite:false,
   responsive: [
      {
        breakpoint: 600,
        settings: {
          dots: true,
          slidesToShow: 2,   // Ensure only 1 slide is shown
        slidesToScroll: 1,
        variableWidth: true
        }
      },
     {
        breakpoint: 480,
        settings: {
          dots: true,
          slidesToShow: 1.5,   // Ensure only 1 slide is shown
        slidesToScroll: 1,
        variableWidth: true
        }
      }
    ]
});

 $('.satisfied-slides').slick({
  slidesToShow: 4,
    infinite: false,
  slidesToScroll: 1,
  arrows: true,
   dots: false,
  autoplay: false,
   responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 479,
        settings: {
          slidesToShow: 1.3,
        }
      }
    ]
});

 $('.recent-deal-inner').slick({
  slidesToShow: 4,
    infinite: true,
  slidesToScroll: 1,
  arrows: true,
   dots: false,
  autoplay: true,
   responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 479,
        settings: {          
            infinite: false,
          autoplay: false,
          slidesToShow: 1.5,
        }
      }
    ]
});

$('.trusted-partners-wrapper').slick({
  slidesToShow: 6,
    infinite: true,
  slidesToScroll: 1,
  arrows: false,
   dots: false,
  autoplay: true,
   responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 5,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 4,
        }
      },
     {
        breakpoint: 640,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 479,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
});

$(document).ready(function() {
    $(".recent-reviews-products").on("click", function(e) {
        e.preventDefault(); // Prevent default behavior

        $("html, body").animate({
            scrollTop: $(".customer-review-outer").offset().top - 80
        }, 800); // Adjust speed (800ms for smooth scrolling)
    });
});
$(document).ready(function () {
    setTimeout(function () {
        if (window.location.href.includes("customer_posted") || 
            window.location.href.includes("newsletter-popup") || 
            window.location.href.includes("form_type=customer")) {
            
            $(".newsletter-success").addClass("modal--is-active");
            $("html").addClass("modal-open");
        }
    }, 2000); // 2-second delay

    $(document).on("click", ".modal__close", function () {
        $(".newsletter-success").removeClass("modal--is-active");
        $("html").removeClass("modal-open");
    });
});


jQuery(document).ready(function($) {
  $(".compatible_vehicles_popup_scroll").mCustomScrollbar({});
    // Open popup
    $(".compatible_vehicles_btn").on("click", function() {
        $(".compatible_vehicles_popup_outer").addClass("active");
    });

    // Close popup when clicking on overlay or close icon
    $(".compatible_vehicles_popup_outer, .close-icon").on("click", function() {
        $(".compatible_vehicles_popup_outer").removeClass("active");
    });

    // Prevent closing when clicking inside popup content
    $(".compatible_vehicles_popup_content").on("click", function(event) {
        event.stopPropagation();
    });

    $(".discountcode").click(function () {
        var $this = $(this);
        navigator.clipboard.writeText($this.text().trim()).then(function () {
            $this.attr("data-tooltip", "Copied to clipboard!");
            setTimeout(function () {
                $this.removeAttr("data-tooltip");
            }, 1500);
        });
    });
    
    
});
